if (typeof AnnouncementBar !== 'function') {
	class AnnouncementBar extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				announcements: '.announcement-bar__announcement',
			};

			this.classes = {
				announcementVisible: 'announcement-bar__announcement--active',
			};

			this.announcements = this.querySelectorAll(this.selectors.announcements);
			this.currentSlide = 0;

			this.init();
		}

		init() {
			this.fadeElements();
		}

		eraseActiveClass() {
			this.elements.announcements.forEach((element) => {
				element.classList.remove(this.classes.isVisible);
			});
		}

		fadeElements() {
			setInterval(() => {
				this.announcements.forEach((element) => {
					element.classList.remove(this.classes.announcementVisible);
				});

				this.currentSlide === this.announcements.length - 1
					? (this.currentSlide = 0)
					: (this.currentSlide += 1);
				this.announcements[this.currentSlide].classList.add(this.classes.announcementVisible);
			}, this.dataset.seconds * 1000);
		}
	}

	if (typeof customElements.get('announcement-bar') == 'undefined') {
		customElements.define('announcement-bar', AnnouncementBar);
	}
}
